const initialState = {
  categories: [],
  allCategories: [],
  paginationInfo: null,
  loading: false,
  error: null,
};

const merchandiseCategoryReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case "SET_LOADING":
      return {
        ...state,
        loading: payload,
      };
    case "SET_ERROR":
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case "CREATE_MERCHANDISE_CATEGORY":
      return {
        ...state,
        categories: [payload, ...state.categories],
        loading: false,
        error: null,
      };
    case "GET_MERCHANDISE_CATEGORIES":
      return {
        ...state,
        categories: payload.categories,
        paginationInfo: payload.paginationInfo,
        loading: false,
        error: null,
      };
    case "GET_ALL_MERCHANDISE_CATEGORIES":
      return {
        ...state,
        allCategories: payload,
        loading: false,
        error: null,
      };
    case "EDIT_MERCHANDISE_CATEGORY":
      return {
        ...state,
        categories: state.categories.map((category) =>
          category._id === payload.id ? payload : category
        ),
        loading: false,
        error: null,
      };
    case "DELETE_MERCHANDISE_CATEGORY":
      return {
        ...state,
        categories: state.categories.filter(
          (category) => category._id.toString() !== payload.toString()
        ),
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export default merchandiseCategoryReducer;
